import { UserRoles } from '../models/enums/UserRoles';
import { ROUTES } from './constants';
import StreamingWEBRTC from '../pages/StreamingWEBRTC';
import EventPage from '../pages/EventPage';
import PublishEventPage from '../pages/PublishEventPage/PublishEventPage';
import RallyPage from '../pages/RallyPage';

export type LocationState = {
    page?: number;
};

export const publicRoutes = [
    {
        path: ROUTES.PUBLIC.BLANK,
        component: StreamingWEBRTC,
        exact: true,
    },
    {
        path: ROUTES.PUBLIC.EVENT,
        component: EventPage,
        exact: false,
    },
    {
        path: ROUTES.AUTHORIZED.STREAMING,
        component: StreamingWEBRTC,
        exact: true,
    },
    {
        path: ROUTES.AUTHORIZED.RALLY,
        component: RallyPage,
        exact: false,
        requiredRoles: [UserRoles.VIEWER, UserRoles.INFLUENCER],
    },
];

export const authorizedRoutes = [
    {
        path: ROUTES.AUTHORIZED.STREAMING,
        component: StreamingWEBRTC,
        exact: true,
        requiredRoles: [UserRoles.ADMIN, UserRoles.INFLUENCER, UserRoles.VIEWER],
    },
    {
        path: ROUTES.AUTHORIZED.EVENT,
        component: EventPage,
        exact: false,
        requiredRoles: [UserRoles.VIEWER, UserRoles.INFLUENCER],
    },
    {
        path: ROUTES.AUTHORIZED.PUBLISH_EVENT,
        component: PublishEventPage,
        exact: true,
        requiredRoles: [UserRoles.INFLUENCER],
    },
];
